import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';

const defaultAd = {
  image: 'https://i.ibb.co/82xMFc1/NOV002-2-07abbaea-3e7d-4c61-8034-9d6593ae1833-1080x.webp',
  textOverlay: 'معاً نكرم محاربينا القدامى. استمتع بخصم 25% على جميع الطلبات واجعل هذا الموسم لا ينسى',
  headline: 'معاً نكرم محاربينا القدامى. استمتع بخصم 25% على جميع الطلبات واجعل هذا الموسم لا ينسى',
  description: 'خصم 25% عروض تخفيضات يوم المحاربين القدامى'
};

export default function SocialAdsBuilderModal({ isOpen, onClose }) {
  const [prompt, setPrompt] = useState('');
  const [aspectRatio, setAspectRatio] = useState('1:1');
  const [numImages, setNumImages] = useState(4);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [adContent, setAdContent] = useState(defaultAd);

  const handleGenerate = () => {
    // TODO: Implement image generation
    console.log('Generating with prompt:', prompt);
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl">
                <div className="absolute right-0 top-0 pr-4 pt-4">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                <div className="flex min-h-[800px]">
                  {/* Left Side - Ad Preview */}
                  <div className="w-1/2 border-r border-gray-200 p-6">
                    <div className="bg-white rounded-lg overflow-hidden">
                      {/* Profile Header */}
                      <div className="flex items-center space-x-2 p-4">
                        <img
                          src="https://i.ibb.co/YkwGqLQ/Screenshot-2024-11-14-at-3-38-45-PM-removebg-preview-1.png"
                          alt="Profile"
                          className="w-10 h-10 rounded-full"
                        />
                        <div>
                          <div className="font-semibold">rinawi</div>
                          <div className="text-sm text-gray-500">Just now</div>
                        </div>
                      </div>

                      {/* Ad Content */}
                      <div className="px-4">
                        <p className="text-sm mb-4" dir="rtl">{adContent.textOverlay}</p>
                        <img
                          src={adContent.image}
                          alt="Ad"
                          className="w-full rounded-lg"
                        />
                        <div className="mt-4">
                          <div className="text-sm text-gray-500">rinawi-food-inc.myshopify.com</div>
                          <div className="flex items-center justify-between mt-2">
                            <div className="text-sm" dir="rtl">{adContent.description}</div>
                            <button className="px-4 py-1 text-sm bg-gray-100 text-gray-800 rounded hover:bg-gray-200">
                              Shop Now
                            </button>
                          </div>
                        </div>

                        {/* Engagement Stats */}
                        <div className="flex items-center justify-between mt-4 py-3 border-t border-gray-200">
                          <div className="flex items-center space-x-2">
                            <span className="text-sm text-gray-500">216</span>
                          </div>
                          <div className="flex items-center space-x-4 text-sm text-gray-500">
                            <span>117 comments</span>
                            <span>44 shares</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Controls */}
                  <div className="w-1/2 bg-gray-900 p-6">
                    <div className="space-y-6">
                      <div>
                        <h2 className="text-xl font-semibold text-white mb-4">Image Generation</h2>
                        <ul className="text-gray-400 text-sm mb-4 space-y-2">
                          <li>• Describe your model and background with a prompt</li>
                          <li>• Use @ to tag and apply a trained custom model</li>
                        </ul>
                      </div>

                      <div>
                        <label className="block text-white text-sm font-medium mb-2">
                          Prompt
                        </label>
                        <textarea
                          value={prompt}
                          onChange={(e) => setPrompt(e.target.value)}
                          className="w-full h-32 bg-gray-800 text-white rounded-lg border-gray-700 focus:border-green-500 focus:ring-green-500"
                          placeholder="photo of @Product-OTTVs/Training-PDbWE cone with filled with peanut butter..."
                        />
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className="block text-white text-sm font-medium mb-2">
                            Text Overlay
                          </label>
                          <input
                            type="text"
                            value={adContent.textOverlay}
                            onChange={(e) => setAdContent(prev => ({ ...prev, textOverlay: e.target.value }))}
                            className="w-full bg-gray-800 text-white rounded-lg border-gray-700"
                            dir="rtl"
                          />
                        </div>

                        <div>
                          <label className="block text-white text-sm font-medium mb-2">
                            Ad Headline
                          </label>
                          <input
                            type="text"
                            value={adContent.headline}
                            onChange={(e) => setAdContent(prev => ({ ...prev, headline: e.target.value }))}
                            className="w-full bg-gray-800 text-white rounded-lg border-gray-700"
                            dir="rtl"
                          />
                        </div>

                        <div>
                          <label className="block text-white text-sm font-medium mb-2">
                            Ad Description
                          </label>
                          <input
                            type="text"
                            value={adContent.description}
                            onChange={(e) => setAdContent(prev => ({ ...prev, description: e.target.value }))}
                            className="w-full bg-gray-800 text-white rounded-lg border-gray-700"
                            dir="rtl"
                          />
                        </div>
                      </div>

                      <div className="flex items-center justify-between">
                        <div>
                          <label className="block text-white text-sm font-medium mb-2">
                            Aspect Ratio
                          </label>
                          <select
                            value={aspectRatio}
                            onChange={(e) => setAspectRatio(e.target.value)}
                            className="bg-gray-800 text-white rounded-lg border-gray-700"
                          >
                            <option>1:1</option>
                            <option>4:5</option>
                            <option>16:9</option>
                          </select>
                        </div>

                        <div>
                          <label className="block text-white text-sm font-medium mb-2">
                            Number of Images
                          </label>
                          <div className="flex space-x-2">
                            {[1, 2, 4].map((num) => (
                              <button
                                key={num}
                                onClick={() => setNumImages(num)}
                                className={`w-8 h-8 rounded-lg ${
                                  numImages === num
                                    ? 'bg-green-500 text-white'
                                    : 'bg-gray-800 text-white'
                                }`}
                              >
                                {num}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div>
                        <button
                          onClick={() => setShowAdvanced(!showAdvanced)}
                          className="flex items-center space-x-2 text-white"
                        >
                          <Cog6ToothIcon className="h-5 w-5" />
                          <span>Advanced Settings</span>
                        </button>
                      </div>

                      <button
                        onClick={handleGenerate}
                        className="w-full py-3 bg-green-500 text-white rounded-lg hover:bg-green-600"
                      >
                        Generate
                      </button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}